import React from 'react';
import CTAButton from './ui/CTAButton';
import SectionHeader from './ui/SectionHeader';
import useRevealOnScroll from '../hooks/useRevealOnScroll';

const LocationSection = () => {
  const { ref, isVisible } = useRevealOnScroll();

  return (
    <section id="location" className="section-shell pt-0">
      <div ref={ref} className={`card-surface p-8 md:p-12 ${isVisible ? 'reveal-visible' : ''} reveal`}>
        <SectionHeader
          eyebrow="Location"
          title="Easy access in Orillia"
          subtitle="Holiday Motel is located at 436 Laclie Street with straightforward access to downtown amenities and local routes."
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="overflow-hidden rounded-2xl border border-brand-border">
            <div className="relative pt-[62%]">
              <iframe
                title="Location Map"
                className="absolute inset-0 h-full w-full"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2889.4591505152787!2d-79.413!3d44.608!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4d2aa1aa68be3c0f%3A0x77b3f20b8e8d5018!2s436%20Laclie%20St%2C%20Orillia%2C%20ON%20L3V%204P6%2C%20Canada!5e0!3m2!1sen!2sus!4v1632544446097!5m2!1sen!2sus"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </div>

          <div className="rounded-2xl border border-brand-border bg-[#fbf7ef] p-6 md:p-8">
            <h3 className="font-heading text-3xl text-brand-primary">Visit Us</h3>
            <p className="mt-4 text-brand-muted leading-relaxed">436 Laclie Street, Orillia, Ontario L3V 4P6</p>
            <p className="mt-2 text-brand-muted leading-relaxed">Phone: 705-325-1316</p>
            <ul className="mt-6 list-disc space-y-2 pl-5 text-sm text-brand-muted">
              <li>Short drive to downtown Orillia</li>
              <li>On-site parking available for cars, trucks, boats, and RVs</li>
              <li>Convenient stop for regional travel</li>
            </ul>
            <CTAButton
              href="https://www.google.com/maps/place/436+Laclie+St,+Orillia,+ON+L3V+4P6,+Canada"
              target="_blank"
              rel="noreferrer"
              className="mt-8"
            >
              Get Directions
            </CTAButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
